// Central, env-backed source for the operator-supplied legal/contact values
// rendered on the public legal pages (Privacy Policy, Terms of Service, SMS
// Opt-In). These are legally binding strings — they MUST come from the
// operator via Vercel env (Production scope), never hardcoded.
//
// Empty-string fallback when unset so the build/render does not crash before
// the operator wires the values; the moment the Vercel envs are set + the
// project is redeployed, every usage renders the real value with no further
// code change.
export const LEGAL = {
  effectiveDate: import.meta.env.VITE_LEGAL_EFFECTIVE_DATE ?? '',
  businessLegalName: import.meta.env.VITE_LEGAL_BUSINESS_NAME ?? '',
  businessAddress: import.meta.env.VITE_LEGAL_BUSINESS_ADDRESS ?? '',
  supportEmail: import.meta.env.VITE_LEGAL_SUPPORT_EMAIL ?? '',
  supportPhone: import.meta.env.VITE_LEGAL_SUPPORT_PHONE ?? '',
  governingState: import.meta.env.VITE_LEGAL_GOVERNING_STATE ?? '',
} as const
